import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AreaMap } from 'src/app/domain/area-map';
import { AreaMapService } from 'src/app/services/area-map.service';
import { ProcessTerrainService } from 'src/app/services/process.service';
import { NotificationManager } from '../notification-manager';


@Component({
    selector: 'change-map-box',
    templateUrl: 'change-map-box.html',
    styleUrls: ['./change-map-box.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChangeMapDialog implements OnInit {

    private interventionCode: string;
    samplingId: number;
    AreaMapList: AreaMap[] = [];
    SelectedMap!: AreaMap;

    constructor(
        private snackbar: MatSnackBar,
        private areaMapService: AreaMapService,
        private processTerrainService: ProcessTerrainService,
        public dialogRef: MatDialogRef<ChangeMapDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any) {

        this.interventionCode = data.interventionCode;
        this.samplingId = data.samplingId;
    }

    ngOnInit() {
        this.areaMapService.getAreaMapListByIntervention(this.interventionCode).subscribe(x => {
            this.AreaMapList = x;
        })
    }

    onCancel() {
        this.dialogRef.close();
    }

    finish() {

        this.processTerrainService.changeAreaMapForProcess(this.interventionCode, this.samplingId, this.SelectedMap.Id).subscribe(x => {
            if (x) {
                NotificationManager.handleSuccess('Plan modifié', this.snackbar);
                this.dialogRef.close(x);
            }
        })
    }
}
